import apiService from '../apiService';

// Staging/local-only billing preview (backend 404s these in production).
const billingPreviewService = {

  async getState() {
    try {
      const response = await apiService.get('/dev/billing-preview');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async toggle() {
    try {
      const response = await apiService.post('/dev/billing-preview/toggle');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default billingPreviewService;
